import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { AuthService } from "../services/auth.service";
import { ProductService } from "../services/product.service";

@Component({
  standalone: false,
  selector: "app-products",
  templateUrl: "./products.component.html",
  styleUrls: ["./products.component.scss"],
})
export class ProductsComponent implements OnInit {
  private visibleProducts: Array<String>;
  public sortedProducts: Array<Object>;
  private excludedProducts = ['JetBridge', 'DataLake', 'AfirsConnect'];

  constructor(
    public productService: ProductService,
    public authService: AuthService,
    private _router: Router
  ) { }

  ngOnInit(): void {
    //sortProducts Average time: 0.209228515625 ms
    if (this.checkProductsAccess()) {
      this.sortProducts();
    }
  }

  checkProductsAccess(): boolean {
    if (!this.authService.user.initialized) {
      this._router.navigate(['/access-denied']);
      return false;
    } else {
      return true;
    }
  }

  sortProducts() {
    this.visibleProducts = this.authService.user.products;
    const products = this.productService.getProducts();
    const copiedProducts = products.slice(0);

    for (let product of products) {
      const allowedProduct = (obj) => obj.name === product.name;
      if (product.name === 'AFIRS Gateway') {
        const afirsGateway = 'AfirsAnalytics';

        if (this.visibleProducts.includes(afirsGateway)) {
          copiedProducts.unshift(copiedProducts.splice(copiedProducts.findIndex(allowedProduct), 1).pop());
        }

      } else {
        if (this.visibleProducts.includes(product.name)) {
          copiedProducts.unshift(copiedProducts.splice(copiedProducts.findIndex(allowedProduct), 1).pop());
        }
      }
    }

    this.sortedProducts = this.reverseOrderOfSortedProducts(copiedProducts);
  }

  reverseOrderOfSortedProducts(copiedProducts: Array<Object>) {
    var left = null;
    var right = null;
    var length = this.visibleProducts.length - 1;

    //Dynamically change length depending on excluded products.
    if (this.excludedProducts.some(excludedProduct => this.visibleProducts.includes(excludedProduct))) {
      this.excludedProducts.forEach((excludedProduct) => {
        if (this.visibleProducts.includes(excludedProduct)) {
          length--;
        }
      });
    }

    //Perform swap of the sorted products.
    for (left = 0, right = length; left < right; left += 1, right -= 1) {
      var temp = copiedProducts[left];
      copiedProducts[left] = copiedProducts[right];
      copiedProducts[right] = temp;
    }
    return copiedProducts;
  }

  productAccess(productName: string) {
    if (productName === 'AFIRS Gateway') {
      productName = "AfirsAnalytics";
    }

    if (!this.visibleProducts) {
      this.visibleProducts = this.authService.user.products;
    }

    return this.visibleProducts.includes(productName) ? true : false;
  }
}
